import { Component, type ErrorInfo, type ReactNode } from 'react';
import { reportError } from '../lib/errorReport';
import { APP_NAME } from '../lib/platform';

/**
 * What the app shows instead of a blank screen when a page crashes: what
 * happened, in a sentence, and a way back. The problem is reported to the
 * server (lib/errorReport.ts).
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    reportError('render', error, info.componentStack ?? undefined);
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="screen screen--center crash" role="alert" data-testid="crash">
        <img src={`${import.meta.env.BASE_URL}icon.svg`} alt="" width={48} height={48} />
        <h1>Something went wrong</h1>
        <p className="muted">
          {APP_NAME} hit a problem it couldn’t recover from. Reload to carry on. If you were in a meeting, you’ll rejoin from the join screen.
        </p>
        <button className="btn btn--primary" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    );
  }
}
